import { Fragment, useRef } from 'react';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';
import CommentTextEditor from './CommentTextEditor';
import { Actions, FormButton } from './Styles';
import { SUBMIT_TYPE } from './constants';
import { Switch, Typography, Stack, FormGroup } from '@mui/material';

// TODO Update PropTypes
const propTypes = {
  isWorking: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isClient: PropTypes.bool.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  quoteAttachment: PropTypes.object,
  refreshQuote: PropTypes.number,
  commentEditorRef: PropTypes.shape({
    // The Quill Object
    current: PropTypes.object,
  }),
};

const CommentsBodyForm = ({
  isClient,
  isWorking,
  formState,
  setFormState,
  onSubmit,
  onCancel,
  quoteAttachment,
  refreshQuote,
  commentEditorRef,
}) => {
  const $textareaRef = useRef();

  const handleTextChange = (key) => (val) => {
    setFormState((prevState) => ({
      ...prevState,
      [key]: val,
    }));
  };

  const handleSubmitTypeChange = (val) => {
    setFormState((prevState) => ({
      ...prevState,
      submitType: val.target.checked ? SUBMIT_TYPE.GLOBAL : SUBMIT_TYPE.LOCAL,
    }));
  };

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <Fragment>
      <CommentTextEditor
        autoFocus
        placeholder={
          formState.commentBody && formState.commentBody !== ''
            ? formState.commentBody
            : intl.get('issue_details_placeholder_add_a_comment')
        }
        value={formState.commentBody}
        onChange={handleTextChange('commentBody')}
        innerRef={$textareaRef}
        quoteAttachment={quoteAttachment}
        refreshQuote={refreshQuote}
        commentEditorRef={commentEditorRef}
      />

      <Actions>
        {!isClient && (
          // Only 2 types [GLOBAL or LOCAL]
          <FormGroup sx={{ mr: 5 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography
                style={{
                  fontSize: '12px',
                }}>
                {intl.get('issue_details_option_comment_type_local')}
              </Typography>

              <Switch
                data-testid="kanban-issueDetails-state-switch"
                checked={formState.submitType === SUBMIT_TYPE.GLOBAL}
                onChange={handleSubmitTypeChange}
              />
              <Typography
                style={{
                  fontSize: '12px',
                }}>
                {intl.get('issue_details_option_comment_type_global')}
              </Typography>
            </Stack>
          </FormGroup>
        )}
        <div>
          <FormButton
            variant="primary"
            isWorking={isWorking}
            onClick={handleSubmit}>
            {intl.get('issue_details_button_save')}
          </FormButton>
          <FormButton variant="empty" onClick={onCancel}>
            {intl.get('issue_details_button_cancel')}
          </FormButton>
        </div>
      </Actions>
    </Fragment>
  );
};

CommentsBodyForm.propTypes = propTypes;

export default CommentsBodyForm;
